<template>
    <modal class="editCsstmManageModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">{{ClientID?"修改":"新增"}}客户资料</div>
        <div class="modal-body">
            <div class="info-box">
                <div class="tr-li">
                    <div class="lable-txt"><span class="red">*</span>编码：</div>
                    <div class="from-input">
                        <input type="text" v-model="code" />
                    </div>
                </div>
                <div class="tr-li">
                    <div class="lable-txt"><span class="red">*</span>名称：</div>
                    <div class="from-input">
                        <input type="text" v-model="name" />
                    </div>
                </div>
                <div class="tr-li">
                    <div class="td-5">
                        <div class="lable-txt">性别：</div>
                        <div class="from-input">
                            <el-radio-group v-model="sex" class="radio-group">
                                <el-radio label="0">男</el-radio>
                                <el-radio label="1">女</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="td-5">
                        <div class="lable-txt">生日：</div>
                        <div class="from-input">
                            <el-date-picker class="from-date"
                                    :clearable="false"
                                    :editable="false"
                                    v-model="birthday"
                                    :disabled="!isEditDate"
                                    @change="(e)=>{birthday=birthday.Format('yyyy-MM-dd');}"
                                    type="date"
                                    placeholder=""
                                    :default-value="(new Date())">
                                </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="tr-li">
                    <div class="td-5">
                        <div class="lable-txt"><span class="red">*</span>手机：</div>
                        <div class="from-input">
                            <input-pattern pattern="phone" :placeholder="ClientID?'':'请输入手机号码'" v-model="mobile" :readonly="ClientID" :maxlength="11"/>
                        </div>
                    </div>
                    <div class="td-5">
                        <div class="lable-txt"><span class="red">*</span>会员等级：</div>
                        <div class="from-input">
                            <el-select v-model="levelID" >
                                <el-option v-for="item in clientLevelList" 
                                    :key="item" 
                                    :label="item.Cstm_LevelName" :value="item.Cstm_LevelID"> </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="tr-li">
                    <div class="lable-txt">喜好：</div>
                    <div class="from-input">
                        <input type="text" v-model="habits" />
                    </div>
                </div>
                <div class="tr-li">
                    <div class="lable-txt">忌讳：</div>
                    <div class="from-input">
                        <input type="text" v-model="taboos"/>
                    </div>
                </div>
                <div class="tr-li">
                    <div class="lable-txt">备注：</div>
                    <div class="from-input">
                        <input type="text" v-model="remark"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="save()">保存</button>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["confirm","close"],
    props:{
        //是否显示
        isShow:{
            type:Boolean,
            default:false
        },
        //客户级别数据
        clientLevelList:{
            type:Array,
            default:null
        },
        data:{
            type:Object,
            default:null
        },
    },
    data(){
        return {
            //是否可修改生日
            isEditDate:true,
            ClientID:"",
            code:"",//编码
            name:"",//名称
            sex:0,//性别，0-男，1-女
            mobile:"",
            birthday:"",//生日
            levelID:"",//等级
            habits:"",//喜好
            taboos:"",//忌讳
            remark:"",//备注
        }
    },
    watch:{
        isShow(newVal){
            if(newVal){
                this.init();
            }
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
            console.log(this.data)
            this.ClientID=this.data?.ClientID;
            this.code=this.data?.ClientCode||"";
            this.name=this.data?.ClientName||"";
            this.sex=(this.data?.Gender||0)+"";
            this.mobile=this.data?.Mobile||"";
            this.birthday=this.data?.Birthday||"1900-01-01";
            this.levelID=this.data?.Cstm_LevelID;
            this.habits=this.data?.Habits;
            this.taboos=this.data?.Taboos;
            this.remark=this.data?.Remark;
            if(this.birthday=="1900-01-01"){
                this.isEditDate=true;
            }else{
                this.isEditDate=false;
            }
        },
        hide(){
            this.$emit("close");
        },
        save(){
            if(!this.code.trim()){
                this.$message.warning('请输入编码');
                return;
            }
            if(!this.name.trim()){
                this.$message.warning('请输入名称');
                return;
            }
            if(!this.levelID){
                this.$message.warning('请选择会员等级');
                return;
            }

            if(!this.ClientID){//只有新增可输入手机号
                if(!this.mobile){
                    this.$message.warning('请输入手机号');
                    return;
                }
                if(!/^1[0-9]{10}$/.test(this.mobile)){
                    this.$message.warning('请输入正确的手机号');
                    return 
                }
            }
          
            let userInfo= this.$auth.getUserInfo();
            const param={
                OperatorName:userInfo?.Login_Name,
                ClientID:this.ClientID,
                ClientName:this.name.trim(),
                ClientCode:this.code.trim(),
                Gender:this.sex,
                Mobile:this.mobile,
                Birthday:this.birthday,
                Cstm_LevelID:this.levelID,
                Habits:this.habits,
                Taboos:this.taboos,
                Remark:this.remark
            }
            const loading = this.$loading({
                text: "数据保存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let methodName="Bestech.CloudPos.Member.AddClient";
            if(this.ClientID){
                methodName="Bestech.CloudPos.Member.ModifyClient";
            }
            this.$httpAES.post(methodName,param).then((d)=>{
                console.log(param,d);
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$emit("confirm");
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('保存客户资料数据失败：'+e);
                console.log('保存客户资料数据失败：'+e);
            })
        }
    }
}
</script>

<style lang="scss">
@import "./editCsstmManageModel.scss";
</style>